export const LISTE_MATERIEL_TYPE = {
  title: 'Liste des types de matériel',
  breadcrumb: {
    racine: 'Accueil',
    parametrage: 'Paramétrage',
    liste: 'Liste type de matériel',
  },
  actions: {
    add: 'Ajouter un type de matériel',
    search: 'Rechercher',
    edit: 'Modifier',
    delete: 'Supprimer',
    archiver: 'Archiver',
  },
  tab: {
    libelle: 'Libellé',
    numerique: 'Numérique',
  },
  yes: 'Oui',
  no: 'Non',
};

export const ADD_MATERIEL_TYPE = {
  titleAdd: 'Ajouter un type de matériel',
  titleEdit: 'Modifier un type de matériel',
  actions: {
    cancel: 'Annuler',
    supprimer: 'Voulez-vous supprimer ce type de matériel',
    archiver: 'Voulez-vous archiver ce type de matériel',
    desarchiver: 'Voulez-vous désarchiver ce type de matériel',
  },
  error: {
    problemOccurred: 'Un problème est survenu',
  },
  informationMaterielType: {
    libelle: 'Libellé',
    numerique: 'Numérique',
    couleur: 'Couleur',
  },
  success: {
    add: 'Le type de matériel a été ajouté avec succès.',
    edit: 'Le type de matériel a été modifié avec succès.',
  },
};
